/* global yaCounter53037871 */

import scrollDepth from 'scroll-depth';
import {router} from './router';

let $document = $(document);
let $html = $(document.documentElement);

function start15SecTimeout() {
	clearTimeout($(window).data('timeout15Sec'));

	$(window).data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function clearText(text) {
	return text.toString().trim().replace(/\s+/g, ' ');
}

function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter53037871) {
		yaCounter53037871.hit(path);
	}
}

function getPageType() {
	return $('.main').hasClass('is-hidden') ? 'past event' : 'main';
}

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

router.on('enter', (prevState, currentState) => {
	start15SecTimeout();

	if (!currentState.route) {
		return Promise.resolve();
	}

	if (prevState.route) {
		virtualHit(currentState.route.generatePath({
			params: currentState.params,
		}));

		scrollDepth.reset();
	}

	return Promise.resolve();
});

$(window).on('scroll', () => {
	if (
		$(window).scrollTop() + innerHeight >= $('.invest__content').offset().top &&
		!$('.invest__content').hasClass('is-visited')
	) {
		$('.invest__content').addClass('is-visited');
		let name = clearText($('.invest__slide[data-slide="1"]').find('.invest__subtitle').text());

		ga('send', 'event', getPageType(), 'question show', name);
	}

	// Отправка имени баннера при его появлении на странице
	let $currentPage = $(`.page.${$html.data('page')}`);

	let $bannerItem = $currentPage.find('.top-block__banner');

	if ($bannerItem.length) {
		if (
			$(window).scrollTop() + innerHeight >= $bannerItem.offset().top &&
			!$bannerItem.hasClass('is-visited')
		) {
			$bannerItem.addClass('is-visited');

			let $bannerName = $bannerItem.find('.top-block__banner-name').text();

			ga('send', 'event', 'banner', 'show', $bannerName, {nonInteraction: true});
		}
	}
});

$document
	.on('invest-next', (e, name) => {
		ga('send', 'event', getPageType(), 'question show', clearText(name));
	})
	.on('email-form-succes', () => {
		ga('send', 'event', 'form', 'send success', 'email');
	})
	.on('main-form-succes', () => {
		ga('send', 'event', 'form', 'send success', 'question');
	})
	.on('video-play', (e, name) => {
		ga('send', 'event', 'video', 'play', name, {nonInteraction: false});
		ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: false});
	})
	.on('video-finish', (e, name) => {
		ga('send', 'event', 'video', 'finish', name);
		ga('rbcspec.send', 'event', 'video', 'finish');
	})
	.on('video-30sec', (e, name) => {
		ga('send', 'event', 'video', 'timing 30s', name, 30);
		ga('rbcspec.send', 'event', 'video', 'timing 30s', '', 30);
	});

$('.project__logo').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.rbc-logo').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

$('.menu__item').on('click', (e) => {
	let name = $(e.currentTarget).text();

	ga('send', 'event', 'nav', 'item click', name);
});

$('.top-block__button-date, .top-block__link, .announcement__link').on('click', (e) => {
	let $button = $(e.currentTarget);

	if ($button.hasClass('announcement__link')) {
		let name = clearText($button.siblings('.announcement__title').text());

		ga('send', 'event', getPageType(), 'add to calendar', name);
	} else {
		ga('send', 'event', getPageType(), 'add to calendar');
	}
});

$('.ask__button button').on('click', () => {
	ga('send', 'event', 'form', 'click button');
});

$('.social__link').on('click', (e) => {
	let name = $(e.currentTarget).data('social');

	ga('send', 'event', 'share', 'project share', name);
});

$('.top-block__banner-link').on('click', (evt) => {
	let $bannerName = $(evt.currentTarget).closest('.top-block__banner').find('.top-block__banner-name').text();

	ga('send', 'event', 'client link', 'banner click', $bannerName);
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.invest__text a').on('click', (e) => {
	let $link = $(e.currentTarget);

	let title = clearText($link.closest('.invest__slide').find('.invest__subtitle').text());
	let text = clearText($link.text());
	let name = `${title} || ${text}`;

	ga('send', 'event', getPageType(), 'question text link', name);
});

$('.last__item').on('click', (e) => {
	let name = clearText($(e.currentTarget).find('.last__item__title').text());

	ga('send', 'event', getPageType(), 'see also', name);
});
